import { jsxs, jsx } from 'react/jsx-runtime';
import { useState, useRef, useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import { cn } from '../../lib/utils.js';
import { LineIcon } from '../ui/icons/LineIcon.js';

const MONTHS_KO = [
  "1월",
  "2월",
  "3월",
  "4월",
  "5월",
  "6월",
  "7월",
  "8월",
  "9월",
  "10월",
  "11월",
  "12월"
];
const MONTHS_EN = [
  "Jan",
  "Feb",
  "Mar",
  "Apr",
  "May",
  "Jun",
  "Jul",
  "Aug",
  "Sep",
  "Oct",
  "Nov",
  "Dec"
];
const CalendarMonth = ({
  value,
  startYear = (/* @__PURE__ */ new Date()).getFullYear(),
  endYear = (/* @__PURE__ */ new Date()).getFullYear() + 10,
  onChange,
  disabled
}) => {
  const [selectYear, setSelectYear] = useState(startYear);
  const [selectMonth, setSelectMonth] = useState();
  const [selectFull, setSelectFull] = useState("");
  const [isFocused, setIsFocused] = useState();
  const ButtonRef = useRef([]);
  const { i18n } = useTranslation();
  const MONTHS = i18n.language === "ko" ? MONTHS_KO : MONTHS_EN;
  const filterAbledMonth = () => {
    return Array.from({ length: 12 }).map((_, idx) => idx + 1).filter((item) => {
      return disabled?.(new Date(selectYear ?? startYear, item, 1)) === false;
    });
  };
  useEffect(() => {
    const abledMonth = filterAbledMonth();
    setIsFocused(abledMonth[0] ? abledMonth[0] - 1 : 0);
  }, [selectYear]);
  useEffect(() => {
    if (!value) {
      setSelectYear((/* @__PURE__ */ new Date()).getFullYear());
      return;
    }
    const year = new Date(value).getFullYear();
    const month = new Date(value).getMonth();
    setSelectYear(year);
    setSelectMonth(month);
    setSelectFull(`${year}.${month}.01`);
    setIsFocused(new Date(value).getMonth());
  }, []);
  const nextYear = () => {
    setSelectYear((prev) => {
      if (!prev) return;
      if (prev >= endYear) return prev;
      return prev + 1;
    });
  };
  const prevYear = () => {
    setSelectYear((prev) => {
      if (!prev) return;
      if (prev <= startYear) return prev;
      return prev - 1;
    });
  };
  const handleMonth = (month) => {
    console.log("월선택1", month, selectMonth);
    setSelectMonth(month);
    if (!selectYear || month === void 0) return;
    const currentDate = `${selectYear}.${month}.01`;
    onChange(new Date(selectYear, month, 1));
    setSelectFull(currentDate);
    setIsFocused(month);
  };
  const moveFocus = (nextIndex) => {
    if (nextIndex < 0 || nextIndex > 11) return;
    setIsFocused(nextIndex);
    ButtonRef.current[nextIndex]?.focus();
  };
  const handleKeyDown = (e, index) => {
    switch (e.key) {
      case "ArrowRight":
        e.preventDefault();
        moveFocus(index + 1);
        break;
      case "ArrowLeft":
        e.preventDefault();
        moveFocus(index - 1);
        break;
      case "ArrowDown":
        e.preventDefault();
        moveFocus(index + 4);
        break;
      case "ArrowUp":
        e.preventDefault();
        moveFocus(index - 4);
        break;
      case "Enter":
        e.preventDefault();
        handleMonth(index);
        break;
    }
  };
  return /* @__PURE__ */ jsxs("div", { className: "flex flex-col py-4", children: [
    /* @__PURE__ */ jsxs("div", { className: "flex items-center justify-between mb-4 h-[42px]", children: [
      /* @__PURE__ */ jsx("strong", { className: "heading-h5 font-weight-bold", children: selectYear }),
      /* @__PURE__ */ jsxs("div", { className: "flex items-center gap-5", children: [
        /* @__PURE__ */ jsx(
          "button",
          {
            onClick: prevYear,
            className: cn(
              "w-6 h-6 rounded-[4px]",
              startYear === selectYear && "opacity-30"
            ),
            "aria-label": "이전 연도로 이동",
            children: /* @__PURE__ */ jsx(LineIcon, { icoColor: "bg-icon-basic-01", icoName: "ico-caret-left" })
          }
        ),
        /* @__PURE__ */ jsx(
          "button",
          {
            onClick: nextYear,
            className: cn(
              "w-6 h-6 rounded-[4px]",
              endYear === selectYear && "opacity-30"
            ),
            "aria-label": "다음 연도로 이동",
            children: /* @__PURE__ */ jsx(LineIcon, { icoColor: "bg-icon-basic-01", icoName: "ico-caret-right" })
          }
        )
      ] })
    ] }),
    /* @__PURE__ */ jsx("div", { className: "grid grid-cols-4 gap-1", children: MONTHS.map((label, idx) => {
      const currentKey = `${selectYear}.${idx}.01`;
      const currentDisabled = disabled?.(new Date(selectYear ?? startYear, idx, 1)) ?? false;
      return /* @__PURE__ */ jsx(
        "button",
        {
          ref: (el) => {
            ButtonRef.current[idx] = el;
          },
          type: "button",
          tabIndex: isFocused === idx ? 0 : -1,
          onClick: () => handleMonth(idx),
          onKeyDown: (e) => handleKeyDown(e, idx),
          disabled: currentDisabled,
          className: cn(
            "flex items-center justify-center rounded-[12px] h-[46px] border border-basic-04 p-4 body-lg text-basic-04 bg-base-white font-weight-medium",
            selectFull === currentKey ? "border-primary-02 text-primary-04" : "hover:bg-basic-background-04",
            currentDisabled && "text-basic-05 pointer-events-none"
          ),
          children: label
        },
        idx
      );
    }) })
  ] });
};

export { CalendarMonth };
